import './IconToggleArrowDown.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var IconToggleArrowDown = function IconToggleArrowDown(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: className
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,8.394L10,13L5.5,8.394c0.735-0.752,1.94-0.766,2.692-0.032c0.011,0.011,0.021,0.021,0.032,0.032\tL10,10.212l1.775-1.818c0.735-0.752,1.941-0.766,2.693-0.032C14.479,8.373,14.49,8.383,14.5,8.394z"
  }));
};
var StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "s1vk749k"
});
export default IconToggleArrowDown;